import { render } from "./GoalUpdateModal.vue?vue&type=template&id=1679720c&scoped=true"
import script from "./GoalUpdateModal.vue?vue&type=script&lang=js"
export * from "./GoalUpdateModal.vue?vue&type=script&lang=js"

import "./GoalUpdateModal.vue?vue&type=style&index=0&id=1679720c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1679720c"]])

export default __exports__